import React, {FunctionComponent} from 'react';
import {useSelector} from 'react-redux';

import {ITableActionProps} from 'components/table/action';
import {ActionButton} from 'components/table/action/action-button';
import {selectEntityData} from 'modules/data';
import {formationRequestAction} from 'modules/data/data-actions';
import {ITableEntityData} from 'modules/data/data-types';
import {EEntityType} from 'shared/constants/entities';
import {TAppState} from 'store/config/types';

export const ButtonFormation: FunctionComponent<ITableActionProps> = ({
    meta,
    entityName,
    wrapper,
    ...props
}: ITableActionProps) => {
    const {selectedRowKeys = []} = useSelector(
        (state: TAppState) => (
            selectEntityData(entityName, EEntityType.TABLE)(state) || {}
        ) as ITableEntityData,
    );
    const handleClick = () => {
        const sectionCodeContext = `app.${entityName}`;
        const referenceUrl = `${meta.referenceUrl}?sectionCodeContext=${sectionCodeContext}`;
        const formNameMessage = meta.actionTitle.replace('Сформировать агрегат ', '');

        formationRequestAction(
            selectedRowKeys,
            referenceUrl,
            `Формирование агрегата ${formNameMessage} запущено`,
            ' Непредвиденная ошибка, просьба обратиться в поддержку. ',
        );
    };

    const Component = wrapper || ActionButton;
    return (
        <Component
            {...props}
            onClick={handleClick}
            actionIcon={meta.actionIcon}
            disabled={!selectedRowKeys.length}
        >
            {meta.actionTitle}
        </Component>
    );
};
